import { jsx as o } from "../../_virtual/jsx-runtime.mjs";
import * as r from "react";
import m from "../../depend/classnames/index.mjs";
import { suffixPx as p } from "../../utils/suffixPx.mjs";
import { iconWrap as v, iconDisplay as h, reoSpin as C } from "./css/icon.mjs";
const d = {
  width: 30,
  color: "#555"
}, k = r.forwardRef((e, n) => {
  const a = r.useRef(null), i = r.useMemo(() => ({
    cursor: e.onClick ? "pointer" : "unset",
    "--svg-fill": e.color,
    "--svg-hover-fill": e.hoverColor ?? e.color
  }), [e.color, e.hoverColor, e.onClick]), t = r.useMemo(() => ({
    "--icon-font-size": p(e.width ?? e.height)
  }), [e.height, e.width]);
  r.useImperativeHandle(n, () => a.current, []);
  const c = r.useCallback((s) => {
    var l;
    (l = e.onClick) == null || l.call(e, s);
  }, [e]), u = r.useCallback((s) => {
    var l;
    (l = e.onMouseEnter) == null || l.call(e, s);
  }, [e]), f = r.useCallback((s) => {
    var l;
    (l = e.onMouseLeave) == null || l.call(e, s);
  }, [e]);
  return /* @__PURE__ */ o(
    "span",
    {
      ref: a,
      className: m(
        v,
        e.className,
        h,
        e.name,
        e.spin ? C : null
      ),
      onClick: c,
      style: { ...i, ...t, ...e.style },
      onMouseEnter: u,
      onMouseLeave: f
    }
  );
}), M = r.forwardRef((e, n) => {
  const a = { ...d, ...e };
  return /* @__PURE__ */ o(
    k,
    {
      ...a,
      ref: n
    }
  );
});
M.displayName = "ReoIcon";
export {
  M as default
};
//# sourceMappingURL=ReoIcon.mjs.map
